import { writable, derived } from 'svelte/store';
export { config } from './userStore';

// Create the writable store with initial value
const initialDelay = parseInt(import.meta.env.VITE_DELAY_HOURS_DEFAULT || '0');
export const delayHours = writable(initialDelay);

// New store for FeatureInfo visibility control
export const showFeatureInfo = writable(false);

// Store for study properties
export const studyProperties = writable(null);

// Helper function to check if a feature is enabled.
// Pass `$studyProperties` as the second argument from Svelte reactive contexts
// ($: statements, {#if} blocks) — a bare call has no reactive dependency, so it
// evaluates once before the store loads and sticks at the default.
export function isFeatureEnabled(featurePath, propsOverride) {
  let currentProperties = propsOverride;
  if (currentProperties === undefined) {
    studyProperties.subscribe(value => {
      currentProperties = value;
    })();
  }

  

  if (!currentProperties?.features) {

    return true; // Default to true if no features defined
  }
  
  // For simple feature paths (no dots), check directly
  if (!featurePath.includes('.')) {
    const isEnabled = currentProperties.features[featurePath] === true;

    return isEnabled;
  }
  
  // For nested feature paths, traverse the object
  const path = featurePath.split('.');
  let current = currentProperties.features;
  
  for (const key of path) {
    if (current[key] === undefined) {
  
      return true; // Default to true if feature not defined
    }
    current = current[key];
  }
  
  
  return current === true;
}

// Helper function to reset delay to default
export function resetDelay() {
  const defaultValue = parseInt(import.meta.env.VITE_DELAY_HOURS_DEFAULT || '0');
  delayHours.set(defaultValue);
}

// Helper function to fetch study properties.
//
// 404 ("Study properties not found") is the expected response when a study has
// no StudyProperties doc yet — fall through to null so the UI uses the
// hard-coded defaults. Don't log it as an error. Other non-OK statuses likely
// mean the auth token wasn't ready (401 from the security filter, body =
// HTML), so `response.json()` would have thrown anyway — degrade silently.
export async function fetchStudyProperties(studyId) {
  try {
    const response = await fetch(`/api/v1/studyProperties/${studyId}`);
    if (response.status === 404) {
      studyProperties.set(null);
      return;
    }
    if (!response.ok) {
      // Auth race or backend hiccup — quiet warn, no scary stack trace.
      console.warn(`fetchStudyProperties: ${response.status} ${response.statusText}`);
      studyProperties.set(null);
      return;
    }
    const data = await response.json();
    studyProperties.set(data?.data ?? null);
  } catch (error) {
    if (error?.name === 'AbortError') return;
    console.warn('fetchStudyProperties:', error?.message || error);
    studyProperties.set(null);
  }
}